/* eslint-disable @typescript-eslint/naming-convention */
import { AppVariables, ReferenceTableModel } from '@shared';
import { RxJsonSchema } from 'rxdb';
import { WorkspaceDatabaseKeys } from './workspace-database-keys';

// todo: check which are nullable and set them nullable in rxdb
export const referenceTableSchema: RxJsonSchema<ReferenceTableModel> = {
	version: 0,
	primaryKey: WorkspaceDatabaseKeys.referenceTableName,
	properties: {
		[WorkspaceDatabaseKeys.referenceTableName]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		}
	},
	attachments: {},
	type: 'object',
	description: ''
};
